var exports = {
  "kL": "xe564cbfb--4719f5--container",
  "x6": "xe564cbfb--4719f5--button",
  "Qs": "xe564cbfb--4719f5--content",
  "wG": "xe564cbfb--4719f5--loader",
};

module.exports = exports;
